import {vm} from '@/main'
import {Dispatcher} from '@/APIDispatcher'

export const CompanyApi = {

  list() {
    return new Promise((resolve, reject) => {
      Dispatcher.post('companies/list', {}).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.companies)
        } else {
          vm.$notify.error('List Failed', 'Company list failed: ' + s.errorCode)
          reject(new Error(s.errorCode))
        }
      })
    })
  },
  details(cid) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('company/details', { company_id: cid }).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.company)
        } else {
          vm.$notify.error('Details Failed', 'Company request failed: ' + s.errorCode)
          reject(new Error(s.errorCode))
        }
      })
    })
  },
  save(company) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('company/set', { company }).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.company) /* if was create will have details */
        } else {
          vm.$notify.error('Save Failed', 'Company request failed: ' + s.errorCode)
          reject(new Error(s.errorCode))
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/company/api.js